var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SegmentsTimeline',_vm._g(_vm._b({},'SegmentsTimeline',Object.assign({}, _vm.$attrs, _vm.strategies, {ride: _vm.ride, isDriverRelation: _vm.isDriverRelation}),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }